export default "__VITE_ASSET__DOMRqKtP__"